import Vue from 'vue'
import VueRouter from 'vue-router'
import store from 'src/store'

import LoginRoutes from 'src/modules/login/routes'
import HomeRoutes from 'src/modules/home/routes'
import UserRoutes from 'src/modules/user/routes'
import TokenRoutes from 'src/modules/token/routes'
import CompanyRoutes from 'src/modules/company/routes'
import MultiprojectRoutes from 'src/modules/multi-project/routes'
import MultitaskRoutes from 'src/modules/multi-task/routes'
import NetworkdiagramRoutes from 'src/modules/network-diagram/routes'
import OntimeRoutes from 'src/modules/on-time/routes'
import TraininsessionRoutes from 'src/modules/training-session/routes'
import AnimationRoutes from 'src/modules/animation/routes'
import PlayerRoutes from 'src/modules/players/routes'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    ...LoginRoutes,
    ...HomeRoutes,
    ...UserRoutes,
    ...TokenRoutes,
    ...CompanyRoutes,
    ...MultiprojectRoutes,
    ...MultitaskRoutes,
    ...NetworkdiagramRoutes,
    ...OntimeRoutes,
    ...TraininsessionRoutes,
    ...AnimationRoutes,
    ...PlayerRoutes,
  ],
})

/**
 * Merge all meta from route
 * Keep last child key is case of conflict on a keys
 *
 * @param {Route} route Route from vue-router
 */
export function getRouteMeta (route) {
  return Object.assign({}, ...route.matched.map(item => item.meta))
}

router.beforeEach((to, from, next) => {
  const { requiresAuth, requiresGuest } = getRouteMeta(to)
  const isAuthenticated = store.getters['me/isAuthenticated']

  if (requiresAuth && !isAuthenticated) {
    return next({ name: 'Login' })
  }

  if (requiresGuest && isAuthenticated) {
    return next({ name: 'Home' })
  }

  return next()
})

export default router
